(() => {
  window.theme = window.theme || {};

  if (window.theme.productSiblingHoverPreviewLoaded) return;

  window.theme.productSiblingHoverPreviewLoaded = true;

  const selectors = {
    link: '[data-product-sibling-hover-image]',
    productInfo: 'product-info',
    activePhoto: '[data-product-media-list] .product__slide.media--active .product__photo',
    fallbackPhoto: '[data-product-media-list] .product__slide .product__photo',
    mediaList: '[data-product-media-list]',
    preview: '[data-product-sibling-hover-preview]',
  };

  const attributes = {
    image: 'data-product-sibling-hover-image',
    srcset: 'data-product-sibling-hover-srcset',
    sizes: 'data-product-sibling-hover-sizes',
    alt: 'data-product-sibling-hover-alt',
    preview: 'data-product-sibling-hover-preview',
    active: 'data-product-sibling-hover-active',
  };

  const classes = {
    visible: 'is-visible',
  };

  function closestHoverLink(target) {
    if (!(target instanceof Element)) return null;
    return target.closest(selectors.link);
  }

  function containsRelatedTarget(element, relatedTarget) {
    return relatedTarget instanceof Node && element.contains(relatedTarget);
  }

  function allowsPointerPreview(event) {
    return document.documentElement.classList.contains('no-touch') && event.pointerType !== 'touch';
  }

  function allowsFocusPreview() {
    return document.documentElement.classList.contains('no-touch') && document.body.classList.contains('is-focused');
  }

  function getPreview(productInfo) {
    const photo = productInfo?.querySelector(selectors.activePhoto) || productInfo?.querySelector(selectors.fallbackPhoto);
    if (!photo) return null;

    let preview = photo.querySelector(selectors.preview);

    if (!preview) {
      preview = document.createElement('div');
      preview.className = 'product-sibling-hover-preview';
      preview.setAttribute(attributes.preview, '');
      preview.setAttribute('aria-hidden', 'true');

      const image = document.createElement('img');
      image.loading = 'eager';
      image.decoding = 'async';

      preview.append(image);
      photo.append(preview);
    }

    return preview;
  }

  function hidePreviews(productInfo, exceptPreview = null) {
    productInfo?.querySelectorAll(selectors.preview).forEach((preview) => {
      if (preview === exceptPreview) return;

      preview.removeAttribute(attributes.active);
      preview.classList.remove(classes.visible);
    });
  }

  function revealPreview(preview, src) {
    requestAnimationFrame(() => {
      if (preview.getAttribute(attributes.active) !== src) return;

      preview.classList.add(classes.visible);
    });
  }

  function showPreview(link) {
    const productInfo = link.closest(selectors.productInfo);
    const preview = getPreview(productInfo);
    const src = link.getAttribute(attributes.image);

    if (!preview || !src) return;

    const image = preview.querySelector('img');
    const srcset = link.getAttribute(attributes.srcset);
    const sizes = link.getAttribute(attributes.sizes);
    const alt = link.getAttribute(attributes.alt) || '';
    const sameImage = image.getAttribute('src') === src;

    preview.setAttribute(attributes.active, src);
    hidePreviews(productInfo, preview);

    if (!sameImage) {
      preview.classList.remove(classes.visible);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');

      if (srcset) image.setAttribute('srcset', srcset);
      if (sizes) image.setAttribute('sizes', sizes);

      image.alt = alt;
      image.src = src;
    }

    if (image.complete) {
      revealPreview(preview, src);
    } else {
      image.addEventListener('load', () => revealPreview(preview, src), {once: true});
    }
  }

  function hidePreview(link) {
    const productInfo = link.closest(selectors.productInfo);

    hidePreviews(productInfo);
  }

  document.addEventListener('pointerover', (event) => {
    const link = closestHoverLink(event.target);
    if (!allowsPointerPreview(event) || !link || containsRelatedTarget(link, event.relatedTarget)) return;

    showPreview(link);
  });

  document.addEventListener('pointerout', (event) => {
    const link = closestHoverLink(event.target);
    if (!link || containsRelatedTarget(link, event.relatedTarget)) return;

    hidePreview(link);
  });

  document.addEventListener('focusin', (event) => {
    const link = closestHoverLink(event.target);
    if (!allowsFocusPreview() || !link) return;

    showPreview(link);
  });

  document.addEventListener('focusout', (event) => {
    const link = closestHoverLink(event.target);
    if (!link || containsRelatedTarget(link, event.relatedTarget)) return;

    hidePreview(link);
  });

  document.addEventListener('pointerdown', (event) => {
    const mediaList = event.target instanceof Element ? event.target.closest(selectors.mediaList) : null;
    if (!mediaList) return;

    hidePreviews(mediaList.closest(selectors.productInfo));
  });
})();
